export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/livings/index/resources/computed.js